var _excluded = ["apiGateway", "autocompleteType", "countryCode", "disabled", "hasError", "hasErrorMessage", "hasClear", "help", "label", "locationNotFoundError", "onBlur", "onChange", "onFocus", "onOptionSelected", "optionsTitle", "placeholder", "value", "withIcon"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useState, useEffect, useRef, forwardRef } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import { Text } from '../Text';
import { Ilocation, Iclose } from '../AgroIcon/icons';
// import logger from '../../utils/logger';

var LocationWithHoc = withCssProps(function (_ref) {
  var apiGateway = _ref.apiGateway,
    _ref$autocompleteType = _ref.autocompleteType,
    autocompleteType = _ref$autocompleteType === void 0 ? 'cities' : _ref$autocompleteType,
    _ref$countryCode = _ref.countryCode,
    countryCode = _ref$countryCode === void 0 ? 'AR' : _ref$countryCode,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    hasError = _ref.hasError,
    _ref$hasErrorMessage = _ref.hasErrorMessage,
    hasErrorMessage = _ref$hasErrorMessage === void 0 ? '' : _ref$hasErrorMessage,
    _ref$hasClear = _ref.hasClear,
    hasClear = _ref$hasClear === void 0 ? false : _ref$hasClear,
    help = _ref.help,
    label = _ref.label,
    locationNotFoundError = _ref.locationNotFoundError,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onOptionSelected = _ref.onOptionSelected,
    optionsTitle = _ref.optionsTitle,
    placeholder = _ref.placeholder,
    value = _ref.value,
    _ref$withIcon = _ref.withIcon,
    withIcon = _ref$withIcon === void 0 ? true : _ref$withIcon,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocus = _useState4[0],
    setIsFocus = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    input = _useState6[0],
    setInput = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    errorMessage = _useState8[0],
    setErrorMessage = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    suggestions = _useState0[0],
    setSuggestions = _useState0[1];
  var _useState1 = useState(-1),
    _useState10 = _slicedToArray(_useState1, 2),
    focusId = _useState10[0],
    setFocusId = _useState10[1];
  var handleKeyDown = function handleKeyDown(e) {
    var keyCode = e.key;
    e.stopPropagation();
    var up = function up() {
      var back = focusId === -1 ? -1 : focusId - 1;
      setFocusId(back);
      e.preventDefault();
    };
    var down = function down() {
      var next = focusId === suggestions.length - 1 ? focusId : focusId + 1;
      setFocusId(next);
      e.preventDefault();
    };
    var enter = function enter() {
      if (isOpen && suggestions && suggestions.length > 0) {
        handleUserSelect(focusId === -1 ? suggestions[0] : suggestions[focusId]);
      } else {
        getSuggestions(input, 'geodetics');
      }
      setIsOpen(!isOpen);
    };
    var tab = function tab() {
      handleBlur(e);
    };
    switch (keyCode) {
      case 'ArrowUp':
        return up();
      case 'ArrowDown':
        return down();
      case 'Enter':
        return enter();
      case 'Tab':
        return tab();
      default:
        return null;
    }
  };
  var handleFocus = function handleFocus(event) {
    setIsFocus(true);
    if (onFocus) {
      onFocus(event);
    }
  };
  var handleBlur = function handleBlur(event) {
    //Si hay una sola sugerencia o ingreso mas de 3 caracteres, selecciono la primera
    if (suggestions && (suggestions.length === 1 || input.length >= 3) && isOpen) {
      handleUserSelect(suggestions[0]);
    }
    setIsOpen(false);
    setIsFocus(false);
    if (onBlur) {
      onBlur(event);
    }
  };
  var handleInputChange = function handleInputChange(e) {
    if (onChange) {
      onChange(e);
    }
    var val = e ? e.target.value.trimStart() : '';
    setInput(val);
    if (val.length >= 3) {
      getSuggestions(val).then(function (res) {
        if (res.data.length > 0) {
          setSuggestions(res.data);
          setIsOpen(true);
          setErrorMessage('');
        } else {
          setErrorMessage(locationNotFoundError);
          clearList();
        }
      })["catch"](function (error) {
        clearList();
        console.error(error);
      });
    } else {
      clearList();
      setErrorMessage('');
    }
  };
  var handleUserSelect = function handleUserSelect(e) {
    setInput(e.description);
    setIsOpen(false);
    getGeodeticPoints(e).then(function (res) {
      if (res.data != null) {
        if (onOptionSelected) {
          onOptionSelected(res.data);
        }
      }
    })["catch"](function (error) {
      console.error(error);
    });
  };
  var getSuggestions = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(text, action) {
      var response, data;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return fetch("".concat(apiGateway, "/location/autocomplete/").concat(autocompleteType, "/").concat(countryCode, "/").concat(text));
          case 1:
            response = _context.v;
            _context.n = 2;
            return response.json();
          case 2:
            data = _context.v;
            if (!(action === 'geodetics')) {
              _context.n = 3;
              break;
            }
            getGeodeticPoints(data[0]).then(function (res) {
              if (res.data != null) {
                if (onOptionSelected) {
                  onOptionSelected(res.data);
                }
              }
            });
            _context.n = 4;
            break;
          case 3:
            return _context.a(2, {
              data: data
            });
          case 4:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function getSuggestions(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var getGeodeticPoints = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(el) {
      var response, data;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return fetch("".concat(apiGateway, "/location/place/").concat(countryCode, "/").concat(el.placeId));
          case 1:
            response = _context2.v;
            _context2.n = 2;
            return response.json();
          case 2:
            data = _context2.v;
            return _context2.a(2, {
              data: data
            });
        }
      }, _callee2);
    }));
    return function getGeodeticPoints(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  var clearList = function clearList() {
    setSuggestions([]);
    onOptionSelected({});
    setIsOpen(false);
  };
  var getSuggestionWithHighlights = function getSuggestionWithHighlights(suggestion) {
    //Elimino acentos ya que el servicio los ignora
    var parsed = suggestion.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    //Matcheo con regex y devuelvo con clase highlight
    var regex = new RegExp(input, 'gi');
    var textHighlighted = parsed.replace(regex, "<b class=\"highlight\">$&</b>");
    return /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: textHighlighted
      }
    });
  };
  useEffect(function () {
    value && value.description && setInput(value.description);
    value && value.placeId === null && setInput('');
    if (hasError !== undefined) {
      hasError && hasErrorMessage && hasErrorMessage.length > 0 ? setErrorMessage(hasErrorMessage) : setErrorMessage();
    }
  }, [hasError, hasErrorMessage, value]);
  return /*#__PURE__*/React.createElement(AgroLocationContainer, props, /*#__PURE__*/React.createElement(InputContainer, null, label ? /*#__PURE__*/React.createElement(StyledLabel, {
    type: "text",
    isFocus: isFocus,
    hasError: hasError || errorMessage && errorMessage.length,
    disabled: disabled,
    value: input,
    hasPlaceholder: placeholder && placeholder.length
  }, label) : null, /*#__PURE__*/React.createElement(StyledInput, {
    type: "text",
    className: "".concat(errorMessage || hasError ? 'input__invalid' : ''),
    value: input,
    placeholder: placeholder,
    onBlur: function onBlur(e) {
      return handleBlur(e);
    },
    onFocus: function onFocus(e) {
      return handleFocus(e);
    },
    onChange: function onChange(e) {
      return handleInputChange(e);
    },
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown(e);
    },
    disabled: disabled,
    isOpen: isOpen
  }), hasClear && /*#__PURE__*/React.createElement(CloseContainer, null, /*#__PURE__*/React.createElement(Iclose, {
    height: "16px",
    width: "16px",
    fill: disabled ? 'gray600' : hasError ? 'red600' : isFocus ? 'blue600' : 'gray700',
    onClick: function onClick() {
      return setInput('');
    }
  })), errorMessage && errorMessage.length && /*#__PURE__*/React.createElement(StyledError, null, errorMessage), help && help.length && !errorMessage && !hasError && !isOpen && /*#__PURE__*/React.createElement(HelpMsg, {
    disabled: disabled,
    hasError: hasError,
    isFocus: isFocus
  }, help)), suggestions && suggestions.length > 0 && /*#__PURE__*/React.createElement(SuggestionWrapper, {
    isOpen: isOpen
  }, optionsTitle && /*#__PURE__*/React.createElement(Text, {
    type: "label-md",
    ml: "sm"
  }, optionsTitle), /*#__PURE__*/React.createElement(SuggestionList, null, suggestions.map(function (suggestion, idx) {
    return /*#__PURE__*/React.createElement(SuggestionContainer, {
      key: idx
    }, withIcon && /*#__PURE__*/React.createElement(Ilocation, {
      fill: "gray800",
      width: "16px",
      height: "16px",
      ml: "sm",
      mr: "xxs"
    }), /*#__PURE__*/React.createElement(Suggestion, {
      role: "button",
      className: idx === focusId ? 'focus' : '',
      onMouseDown: function onMouseDown() {
        return handleUserSelect(suggestion);
      },
      tabindex: "1",
      withIcon: withIcon
    }, getSuggestionWithHighlights(suggestion.description)));
  }))));
});
var AgroLocation = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(LocationWithHoc, _extends({
    inputRef: ref
  }, props));
});
export { AgroLocation };
AgroLocation.propTypes = {
  apiGateway: PropTypes.string,
  autocompleteType: PropTypes.oneOf(['cities', 'addresses']),
  countryCode: PropTypes.oneOf(['AR', 'BR', 'BO', 'CL', 'CO', 'PE', 'PY', 'UY']),
  disabled: PropTypes.bool,
  hasClear: PropTypes.bool,
  hasError: PropTypes.bool,
  hasErrorMessage: PropTypes.string,
  help: PropTypes.string,
  label: PropTypes.string,
  locationNotFoundError: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onOptionSelected: PropTypes.func,
  optionsTitle: PropTypes.string,
  placeholder: PropTypes.string,
  ref: PropTypes.any,
  value: PropTypes.object,
  withIcon: PropTypes.bool
};
var AgroLocationContainer = styled.div.withConfig({
  displayName: "AgroLocation__AgroLocationContainer",
  componentId: "loei3f-0"
})(["position:relative;"]);
var StyledInput = styled.input.withConfig({
  displayName: "AgroLocation__StyledInput",
  componentId: "loei3f-1"
})(["font-family:", ";font-size:14px;line-height:17px;background:transparent;border:1px solid ", ";border-radius:", ";padding:13px 16px 12px 16px;overflow:hidden;text-overflow:ellipsis;transition:all 0.3s ease;color:", ";-webkit-appearance:none;::placeholder{font-size:14px;line-height:24px;overflow:hidden;text-overflow:ellipsis;}", " &:focus{border-color:", ";color:", ";outline:none;}", ";&.input__invalid{border:1px solid ", ";}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontFamily;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.gray700;
}, function (_ref6) {
  var isOpen = _ref6.isOpen;
  return isOpen ? '8px 8px 0px 0px' : '8px';
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.gray800;
}, function (_ref8) {
  var disabled = _ref8.disabled,
    theme = _ref8.theme;
  return disabled && css(["border:1px solid ", ";-webkit-text-fill-color:", ";color:", ";pointer-events:none;opacity:1;"], theme.colors.gray600, theme.colors.gray600, theme.colors.gray600);
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.blue600;
}, function (_ref0) {
  var theme = _ref0.theme;
  return theme.colors.gray900;
}, function (_ref1) {
  var value = _ref1.value;
  return value && css(["color:", ";"], function (_ref10) {
    var theme = _ref10.theme;
    return theme.colors.gray900;
  });
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.red600;
});
var StyledError = styled.span.withConfig({
  displayName: "AgroLocation__StyledError",
  componentId: "loei3f-2"
})(["color:", ";font-size:12px;line-height:18px;font-weight:500;letter-spacing:-0.1px;margin-top:4px;font-family:", ";"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.red600;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.fontFamily;
});
var HelpMsg = styled.span.withConfig({
  displayName: "AgroLocation__HelpMsg",
  componentId: "loei3f-3"
})(["color:", ";font-size:12px;line-height:18px;font-weight:500;margin-top:4px;letter-spacing:-0.1px;font-family:", ";", "}"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.gray800;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontFamily;
}, function (_ref16) {
  var theme = _ref16.theme,
    hasError = _ref16.hasError,
    isFocus = _ref16.isFocus,
    disabled = _ref16.disabled;
  return css(["color:", ";"], disabled ? theme.colors.gray600 : hasError ? theme.colors.red600 : isFocus ? theme.colors.blue600 : theme.colors.gray800);
});
var InputContainer = styled.div.withConfig({
  displayName: "AgroLocation__InputContainer",
  componentId: "loei3f-4"
})(["display:flex;flex-direction:column;position:relative;input:-webkit-autofill,input:-webkit-autofill:focus,textarea:-webkit-autofill,textarea:-webkit-autofill:hover,textarea:-webkit-autofill:focus,select:-webkit-autofill,select:-webkit-autofill:hover,select:-webkit-autofill:focus{-webkit-text-fill-color:", ";-webkit-box-shadow:0 0 0px 1000px rgba(255,255,255,0) inset;transition:background-color 5000s ease-in-out 0s;}"], function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.gray900;
});
var StyledLabel = styled.label.withConfig({
  displayName: "AgroLocation__StyledLabel",
  componentId: "loei3f-5"
})(["font-family:", ";font-size:14px;line-height:19px;display:flex;align-items:center;transition:all 100ms ease;position:absolute;top:14px;padding:0px 0px 0px 16px;font-weight:normal;cursor:text;pointer-events:none;color:", ";opacity:", ";", "}"], function (_ref18) {
  var theme = _ref18.theme;
  return theme.fontFamily;
}, function (_ref19) {
  var theme = _ref19.theme,
    disabled = _ref19.disabled,
    isFocus = _ref19.isFocus;
  return disabled ? theme.colors.gray600 : isFocus ? theme.colors.gray900 : theme.colors.gray800;
}, function (_ref20) {
  var hasPlaceholder = _ref20.hasPlaceholder;
  return hasPlaceholder ? '0' : '1';
}, function (_ref21) {
  var theme = _ref21.theme,
    hasError = _ref21.hasError,
    isFocus = _ref21.isFocus,
    value = _ref21.value,
    disabled = _ref21.disabled;
  return value && css(["opacity:1;font-size:12px;line-height:18px;top:-8px;left:12px;color:", ";background-color:white;padding:0px 4px;z-index:1;"], disabled ? theme.colors.gray600 : hasError ? theme.colors.red600 : isFocus ? theme.colors.blue600 : theme.colors.gray800);
});
var CloseContainer = styled.div.withConfig({
  displayName: "AgroLocation__CloseContainer",
  componentId: "loei3f-6"
})(["position:absolute;right:16px;top:14px;z-index:1;cursor:pointer;"]);
var SuggestionWrapper = styled.div.withConfig({
  displayName: "AgroLocation__SuggestionWrapper",
  componentId: "loei3f-7"
})(["display:", ";z-index:5;background-color:", ";border-width:0px 1px 1px 1px;border-style:solid;border-color:", ";box-sizing:border-box;box-shadow:0px 3px 6px rgba(0,0,0,0.07);border-radius:0px 0px 8px 8px;width:100%;padding:12px 0px;"], function (_ref22) {
  var isOpen = _ref22.isOpen;
  return isOpen ? 'block' : 'none';
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.colors.white;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.colors.blue600;
});
var SuggestionList = styled.ul.withConfig({
  displayName: "AgroLocation__SuggestionList",
  componentId: "loei3f-8"
})(["list-style:none;margin:0;padding:0;"]);
var SuggestionContainer = styled.div.withConfig({
  displayName: "AgroLocation__SuggestionContainer",
  componentId: "loei3f-9"
})(["display:flex;align-items:center;width:100%;&.focus,&.selected{background-color:", ";}&:hover:not(.selected){background-color:", ";}"], function (_ref25) {
  var theme = _ref25.theme;
  return theme.colors.gray300;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.colors.gray200;
});
var Suggestion = styled.li.withConfig({
  displayName: "AgroLocation__Suggestion",
  componentId: "loei3f-10"
})(["font-family:", ";font-size:14px;line-height:20px;color:", ";padding:", ";cursor:pointer;box-sizing:border-box;max-height:40px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-tap-highlight-color:transparent;display:flex;align-items:center;width:100%;span{display:block;}span .highlight{font-weight:600;}"], function (_ref27) {
  var theme = _ref27.theme;
  return theme.fontFamily;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.colors.black;
}, function (_ref29) {
  var withIcon = _ref29.withIcon;
  return withIcon ? '12px 0px' : '12px 16px';
});